import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography } from '@material-ui/core';
import LazyImg from './LazyImg'

const useStyles = makeStyles((theme) => ({
    cardRoot: {
        width: "100%",
        height: '100%',
        position: 'relative',
    },
    serviceMedia: {
        '& div': {
            paddingBottom: theme.spacing(25),
            [theme.breakpoints.only('xs')]: {
                paddingBottom: theme.spacing(12),
            },
        }
    },
    imgGrad: {
        display: 'block',
        position: "absolute",
        top: 0,
        width: '100%',
        height: theme.spacing(25),
        [theme.breakpoints.only('xs')]: {
            height: theme.spacing(12),
        },
        background: 'linear-gradient(to bottom, #00000030, #000000bf)'
    },
    cardTitle: {
        position: 'absolute',
        color: '#fff',
        top: theme.spacing(18),
        [theme.breakpoints.only('xs')]: {
            top: theme.spacing(6),
            left: theme.spacing(2),
        },
        left: theme.spacing(4),
        textShadow: '1px 1px 2px #0000009e'
    }
}))

export default function LargeServiceCard({heading, ph, src, children}) {
    const classes = useStyles();
    return (
        <Card className={classes.cardRoot} variant='outlined'>
            <div className={classes.serviceMedia}>
                <LazyImg placeholder={ph} 
                    srcSet={`${src[0]} 400w, ${src[1]} 750w, ${src[2]} 1250w`} 
                    sizes="100vw"
                />
            </div>
            <div className={classes.imgGrad}></div>
            <CardContent>
                <Typography 
                    className={classes.cardTitle} 
                    gutterBottom variant="h5" 
                    component="h3"
                >
                    {heading}
                </Typography>
                <div>
                    {children}
                </div>
            </CardContent>
        </Card>
    )
}